
<div style="padding: 20px;">
  <div class="phone-number-input-container">
    <input type="text" [(ngModel)]="phoneNumber" id="dialPadNumber" (keypress)="validateInput($event)" maxlength="10"
      placeholder="Enter phone number" class="phone-number-input" [attr.autocomplete]="'consult-phone'">
  </div>
  <div style="display: flex;gap: 16px; padding: 8px;" mat-dialog-actions>
    <button mat-button (click)="blindTransfer()">Transfer</button>
    <button mat-button (click)="consulted()">Consult</button>
    <button mat-button (click)="closeDialog()">Close</button>
  </div>
</div>
